import {
  ENewbuildingInfrastructureActionTypes,
  TSetNewbuildingInfrastructureAction,
} from 'shared/actions/newbuildingInfrastructure';
import { TNewbuildingInfrastructureState } from 'shared/types/newbuildingInfrastructure';

export const defaultState: TNewbuildingInfrastructureState = {
  regularInfrastructureItems: [],
};

export function newbuildingInfrastructureReducer(
  state: TNewbuildingInfrastructureState = defaultState,
  action: TSetNewbuildingInfrastructureAction,
): TNewbuildingInfrastructureState {
  switch (action.type) {
    case ENewbuildingInfrastructureActionTypes.SetInfrastructure:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
